import '../../assets/components/ProductCardFilesTab/productCardFilesTab.css';const n = "_accordionContent_121hv_24", o = "_fileLink_121hv_3", c = "_iconPad_121hv_20", t = {
  accordionContent: n,
  fileLink: o,
  iconPad: c
};
export {
  n as accordionContent,
  t as default,
  o as fileLink,
  c as iconPad
};
